// BabyMobile.ca — swipeable/clickable photo slider on product cards
// (catalog, bestsellers, related products) so shoppers can flip through
// a product's photos without opening the product page.
(function () {
  function initSlider(root) {
    var track = root.querySelector('[data-rd-slider-track]');
    if (!track) return;
    var slides = track.querySelectorAll('.rd-card-slider-img');
    if (slides.length < 2) return;

    var dots = root.querySelectorAll('[data-rd-slider-dots] span');
    var prevBtn = root.querySelector('[data-rd-slider-prev]');
    var nextBtn = root.querySelector('[data-rd-slider-next]');

    function activeIndex() {
      var slideWidth = track.clientWidth || 1;
      return Math.round(track.scrollLeft / slideWidth);
    }

    function updateDots() {
      var idx = activeIndex();
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
    }

    function goTo(index) {
      var clamped = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: clamped * track.clientWidth, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(activeIndex() - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(activeIndex() + 1);
      });
    }

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateDots, 80);
    });

    // Guard: a touch/mouse drag that ends on a different slide than it
    // started shouldn't also trigger the card's outer <a> navigation.
    var dragStartX = null;
    var dragged = false;
    track.addEventListener('pointerdown', function (e) {
      dragStartX = e.clientX;
      dragged = false;
    });
    track.addEventListener('pointermove', function (e) {
      if (dragStartX !== null && Math.abs(e.clientX - dragStartX) > 8) dragged = true;
    });
    root.addEventListener(
      'click',
      function (e) {
        if (dragged) {
          e.preventDefault();
          e.stopPropagation();
        }
        dragged = false;
        dragStartX = null;
      },
      true
    );
  }

  function initAll() {
    document.querySelectorAll('[data-rd-card-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init sliders inside content swapped in later (e.g. product
  // recommendations loaded via fetch, quick view, infinite-scroll grids).
  document.addEventListener('rd:content-updated', initAll);
})();
